<template>
  <PageContainer>
    <div class="flex flex-col align-center">
      <h1>Admin</h1>
      <h2>Log in as:</h2>
      <input type="text" name="user_id" v-model="userId" placeholder="User ID">
      <button @click="logInAs(userId)">Log in</button>
      <h2 class="mt-8">Log out current user:</h2>
      <button @click="logOut()">Log out</button>
      <h2>View all users:</h2>
      <button @click="viewUsers()">View users</button>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import User from '@/models/user'

export default {
  name: 'AdminPage',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      userId: undefined,
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
    async logInAs(id) {
      const user = await User.get(id)
      console.log('Attempting to log in as user:', user)
      this.$router.push('/')
    },
    async logOut() {
      const user = await User.getCurrentUser()
      user.logout()
        .then(() => {
          this.$router.push('/')
        })
    },
    viewUsers() {
      this.$router.push('/admin/users')
    },
  },
  computed: {
  }
}
</script>